import { render, staticRenderFns } from "./DashboardFastmove.vue?vue&type=template&id=82a8de82&scoped=true&"
import script from "./DashboardFastmove.vue?vue&type=script&lang=js&"
export * from "./DashboardFastmove.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFastmove.vue?vue&type=style&index=0&id=82a8de82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a8de82",
  null
  
)

export default component.exports